import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ds-option-card",
  templateUrl: "./ds-option-card.component.html",
  styleUrls: ["./ds-option-card.component.scss"],
})
export class DsOptionCardComponent {
  @Input() label = "";
  @Input() description = "";
  /** Optional ds-icon name rendered at the start of the card. */
  @Input() icon = "";
  @Input() selected = false;
  @Input() disabled = false;
  @Output() selectedChange = new EventEmitter<void>();

  onSelect(): void {
    if (this.disabled) {
      return;
    }
    this.selectedChange.emit();
  }
}
